import React, { useEffect } from 'react';
import { usePageContent } from '../contexts/PageContentContext.tsx';

export const MetaTags: React.FC = () => {
  const { content } = usePageContent();
  const resultContent = content?.result;

  useEffect(() => {
    if (!resultContent || typeof resultContent !== 'object') return;

    // Update title
    if (typeof resultContent.title === 'string') {
      document.title = resultContent.title;
    }

    // Meta description
    if (typeof resultContent.metaDescription === 'string') {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('resultContent', resultContent.metaDescription);
    }

    // Meta keywords
    if (typeof resultContent.metaKeywords === 'string') {
      let meta = document.querySelector('meta[name="keywords"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'keywords');
        document.head.appendChild(meta);
      }
      meta.setAttribute('resultContent', resultContent.metaKeywords);
    }

    // JSON-LD
    let jsonLdScript: HTMLScriptElement | null = null;
    if (typeof resultContent.jsonLdData === 'string') {
      jsonLdScript = document.createElement('script');
      jsonLdScript.type = 'application/ld+json';
      jsonLdScript.text = resultContent.jsonLdData;
      document.head.appendChild(jsonLdScript);
    }

    // Inject custom scripts
    const addedScripts: HTMLScriptElement[] = [];
    if (Array.isArray(resultContent.scripts)) {
        console.log("resultContent scripts", resultContent.scripts)
      resultContent.scripts.forEach((script) => {
        if (typeof script?.content === 'string') {
          const el = document.createElement('script');
          el.text = script.content;
          el.async = true; // Ensure the script is executed asynchronously
          el.onload = () => console.log(`Script loaded: ${script.content}`);
          el.onerror = (e) => console.error(`Script load error: ${script.content}`, e);
          if (script.placement === 'head') {
            document.head.appendChild(el);
          } else {
            document.body.appendChild(el);
          }
          addedScripts.push(el);
        }
      });
    }

    // Cleanup
    return () => {
      if (jsonLdScript) jsonLdScript.remove();
      addedScripts.forEach(s => s.remove());
    };
  }, [resultContent]);

  return null;
};
